module.exports = __webpack_public_path__ + "static/3-e0516b602a0aabf7a8d6986d26582690.jpg";